import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { Projectile } from '../Projectile';
import { ROCK_THROWER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class RockThrower extends BaseUnit {
  private attackTimer: number = 0;
  private throwPhase: number = 0;
  private projectiles: Projectile[];

  constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, projectiles: Projectile[]) {
    super(scene, x, y, slotIndex);
    this.projectiles = projectiles;
    this.targetPriority = 'mostClustered';
    this.draw();
  }

  getDamage(): number {
    const perUnitDamage = Math.round(ROCK_THROWER.baseDamage * this.bonusDamageMult * this.globalDamageMult);
    return perUnitDamage * this.stackCount;
  }

  getProjectileCount(): number {
    return 1 + this.bonusProjectiles;
  }

  update(time: number, delta: number, enemies: Enemy[]): void {
    // Animate throw
    if (this.throwPhase > 0) {
      this.throwPhase -= delta * 0.003;
      if (this.throwPhase < 0) this.throwPhase = 0;
    }

    // Fire at nearest enemy
    this.attackTimer -= delta;
    if (this.attackTimer <= 0) {
      const target = this.findTarget(enemies, ROCK_THROWER.range);
      if (target) {
        this.attackTimer = this.getEffectiveAttackInterval(ROCK_THROWER.attackInterval);
        this.throwPhase = 1;
        this.fire(target);
      } else {
        // Reset timer to 0 so we can fire immediately when enemy appears
        this.attackTimer = 0;
      }
    }

    this.draw();
  }

  private fire(target: Enemy): void {
    const count = this.getProjectileCount();
    const damage = this.getDamage();
    const spread = 30; // Vertical spread between projectiles

    for (let i = 0; i < count; i++) {
      // Spread projectiles vertically around the target
      const offsetY = count > 1 ? (i - (count - 1) / 2) * spread : 0;
      const proj = new Projectile(this.scene, this.x + 10, this.y - 10, {
        damage,
        speed: ROCK_THROWER.projectileSpeed,
        piercing: false,
        projectileType: 'rock',
        targetX: target.x,
        targetY: target.y + offsetY,
        stunDuration: this.stunDuration,
      });
      this.projectiles.push(proj);
    }
  }

  draw(): void {
    if (this.throwPhase <= 0) {
      this.sprite.setTexture('friendly_rock_idle');
    } else {
      // throwPhase goes from 1.0 down to 0.0
      // We baked frames 0-7 where 0 is start, 7 is end of throw
      let frame = Math.floor((1 - this.throwPhase) * 8);
      if (frame < 0) frame = 0;
      if (frame > 7) frame = 7;
      this.sprite.setTexture(`friendly_rock_${frame}`);
    }

    this.graphics.clear();
    // Level indicator
    if (this.level > 1) {
      this.graphics.fillStyle(0xffd700, 1);
      for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
        this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
      }
    }
  }
}
